const INITIAL_STATE = {
  trends: {
    dateOfLastReading: new Date().toISOString(),
    numberOfNewPosts: 0
  }
}
const notificationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_NUMBER_OF_NEW_POSTS':
      return {
        ...state,
        trends: {...state.trends, numberOfNewPosts: action.numberOfNewPosts}
      }
    case 'SET_DATE_OF_LAST_READING':
      return {
        ...state,
        trends: { ...state.trends, dateOfLastReading: action.dateOfLastReading }
      }
    default:
      return state
  }
}

export default notificationReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/notificationReducer.js